import { Space } from "~/lib/types";
import { CicdJob } from "~/pages/cicd/CicdJob";

interface CicdJobProps {
  space: Space;
}

const JobEntryPage = ({ space }: CicdJobProps) => {
  return <CicdJob space={space} />;
};

export default JobEntryPage;
